<template>
  <div class="content">
    <div class="md-layout">
      <div class="md-layout-item">
        <md-card>
          <md-card-header
            v-if="alarmList.length>0"
            :data-background-color=" this.alarmListPriority "
          >
            <h4 class="title">
              Alarmes
            </h4>
          </md-card-header>
          <md-card-header
            v-else
            :data-background-color=" this.alarmListPriority "
          >
            <h4 class="title">
              Alarmes
            </h4>
          </md-card-header>
          <md-card-content>
            <div class="md-layout">
              <div class="md-layout-item md-medium-size-100">
                <md-table v-model="alarmList">
                  <md-table-row
                    slot="md-table-row"
                    slot-scope="{ item }"
                  >
                    <md-table-cell md-label="Site">
                      {{ item.site }}
                    </md-table-cell>
                    <!-- <md-table-cell md-label="Host">{{ item.host.substring(item.host.indexOf('_')+1,item.host.length)  }}</md-table-cell> -->
                    <md-table-cell md-label="Equipamento">
                      {{ item.host.substring(item.host.indexOf('_')+1,item.host.length) }} : {{ item.application }}
                    </md-table-cell>
                    <md-table-cell md-label="Atributo">
                      {{ item.item }}
                    </md-table-cell>
                    <md-table-cell md-label="Descrição">
                      {{ item.description }}
                    </md-table-cell>
                    <md-table-cell md-label="Reconhecido">
                      <a
                        v-if="item.acknowledged=='NÃO'"
                        style="color:red;"
                      > {{ item.acknowledged }}</a>
                      <a
                        v-else
                        style="color:black;"
                      > {{ item.acknowledged }} </a>
                    </md-table-cell>
                    <md-table-cell md-label="Tempo Ativo">
                      {{ item.clock }}
                    </md-table-cell>
                    <!-- <md-table-cell md-label="Opções">{{ item.acknowledged=="NÃO" ? "Reconhecer" : "" }} </md-table-cell> -->
                  </md-table-row>
                </md-table>
              </div>
            </div>
          </md-card-content>
        </md-card>
      </div>
    </div>
  </div>
</template>

<script>
import { userService } from "../_services";
import { getUserSession } from "../_services/localstorage";

export default {
  props: ["alarms"],
  data() {
    return {
      type: ["info", "success","warning", "warning", "danger",""],
      notifications: {
        topCenter: false
      },
      oldList: [],
      alarmList: [],
      triggers:[],
      sites:[],
      alarmListPriority: "green",
      timer: ""
    };
  },
  watch: {
   alarms: {
     handler: function() {
       this.alarmList=this.alarms;
     },
     deep: true
   }
 },
  created: function() {

      this.sites = JSON.parse(localStorage.getItem("sites"));
      this.loadData();
      this.timer = setInterval(this.loadData, 5000);
      this.checkSite();
      this.timer = setInterval(this.checkSite, 1000);
      this.timer = setInterval(this.checkOnlineSite, 1000);
      // console.log(this.sites);

  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  methods: {
    notifyVue(messageIn,priority) {
      this.$notify({
        message:messageIn,
        icon: "add_alert",
        horizontalAlign: "right",
        verticalAlign: "top",
        type: this.type[priority]
      });
    },
    loadData: function () {
      userService.AsingZabbixProblems(this.sites).then(zabbixProblems => {

        var highestAlarmLevel=0;
        var i =0,finalseconds=0,seconds=0, minutes=0,hours=0,days=0;
        let timestampNow = { seconds: Date.now()/ 1000, nanoseconds: 0 };
        for(i=0;i<zabbixProblems.length;i++){
          seconds = timestampNow.seconds-zabbixProblems[i].clock; // firebase data
          zabbixProblems[i].clock="";
          finalseconds = parseInt(seconds, 10) % 60;
          minutes = parseInt(seconds / 60, 10) % 60;
          hours = parseInt(seconds / 3600, 10) % 24;
          days = parseInt(seconds / 86400, 10);
          if(days>0){zabbixProblems[i].clock+=days+"d ";}
          if(hours>0){zabbixProblems[i].clock+=hours+"h ";}
          if(minutes>0){zabbixProblems[i].clock+=minutes+"m ";}
          zabbixProblems[i].clock+=finalseconds+"s";
          if(zabbixProblems[i].priority>highestAlarmLevel && zabbixProblems[i].acknowledged === "NÃO"){
            highestAlarmLevel=zabbixProblems[i].priority;
          }
        }
        this.alarmListPriority="green";
        if(highestAlarmLevel>1){
          this.alarmListPriority="orange";
        }
        if(highestAlarmLevel>3){
          this.alarmListPriority="red";
        }
        this.alarmList = zabbixProblems;



      });
    },
    cancelAutoUpdate: function() { clearInterval(this.timer); },
    checkSite: function () {

      // console.log("check "+this.user.activeentity+ " > "+this.glpiActiveEntity)

      this.user = getUserSession();
      this.sites = JSON.parse(localStorage.getItem("sites"));
      // console.log(this.user);
      // this.totalTickets=this.totalTickets+1;

      if(this.user.activeentity!=this.glpiActiveEntity){
        this.loading=true;
        // console.log("Search1");
        this.loadData();
        this.glpiActiveEntity=this.user.activeentity;


      }









  },
  checkOnlineSites: function () {

    // console.log("check "+this.user.activeentity+ " > "+this.glpiActiveEntity)

    this.sites = JSON.parse(localStorage.getItem("sites"));
    // console.log(this.user);
    // this.totalTickets=this.totalTickets+1;

    if(this.sites.length!=this.oldSites.length){
      this.loading=true;
      // console.log("Search1");
      this.loadData();
      this.oldSites=this.sites;
    }

  },
  }
};
</script>
